<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%; margin-top: 10px">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>数据分析</h3>
          </div>
          <div class="table-title-btn">
            <!-- <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button> -->
          </div>
        </div>
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="决策模型：">
                <el-select @change="ChangeDecisionId" v-model="searchForm.decisionId" clearable placeholder="请选择">
                  <el-option v-for="item in ModelDecision" :key="item.id" :label="item.groupName" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="控制日期：">
                <el-date-picker v-model="searchForm.controlDate" align="right" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="handleSearch"> </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="控制日期：">
                <el-date-picker v-model="searchForm.time" type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="handleSearch" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
                </el-date-picker>
              </el-form-item> -->
              <!-- <el-form-item label="时间阶段：">
            <el-time-picker is-range v-model="searchForm.controlTime" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm:ss" format="HH:mm:ss" @change="handleSearch">
            </el-time-picker>
          </el-form-item> -->
              <el-form-item>
                <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
                <el-button type="button" ass="button" @click="handleRest">重置</el-button>
                <!-- <span style="margin-left: 20px; color: #647189">注意：黑色虚线表示待确定，红色虚线表示调控失败，绿色虚线表示调控成功</span> -->
              </el-form-item>
            </el-form>
            <el-button type="primary" style="margin-top: -20px; margin-left: 20px" class="button" @click="upDay(0)">上一天</el-button>
            <el-button v-show="timer !== searchForm.controlDate" type="primary" style="margin-top: -20px" class="button" @click="upDay(1)">下一天</el-button>
            <div class="growthModelCard" v-loading="isLoading">
              <el-row :gutter="10">
                <el-col :md="12" :lg="12" :xl="8" v-for="(item2, index2) in tableData" :key="index2">
                  <div class="grid-content bg-purple" style="border: 1px solid #d8d8d8; border-radius: 5px">
                    <div class="growth-titile-container">
                      <h5>
                        {{ item2.paramName + '_' + item2.controlName }}
                        <span class="title_1">
                          最大值:
                          <span class="fs"> {{ item2.dataMap.max }}, </span>
                          最小值:
                          <span class="fs"> {{ item2.dataMap.min }}, </span>
                          白天平均值:
                          <span class="fs"> {{ item2.dataMap.day }}, </span>
                          夜晚平均值:
                          <span class="fs">
                            {{ item2.dataMap.night }}
                          </span>
                        </span>
                        <span class="title_1">
                          {{ '（' + item2.symbol + '）' }}
                        </span>
                      </h5>
                    </div>
                    <div class="growth-content-container">
                      <div :id="item2.id + '0'" style="width: 100%; height: 120%; display: inline-block"></div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="empty-box" v-if="tableData.length == 0">
              <img :src="empty_img" />
            </div>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import echarts from 'echarts'
import moment from 'moment'

export default {
  data() {
    return {
      timer: this.$utils.zhDate(new Date().getTime()),
      searchForm: {
        // 查询条件字段
        decisionId: '',
        paramType: '',
        controlDate: this.$utils.zhDate(new Date().getTime()),
        controlTime: ['00:00:00', '23:59:59'],
        startDate: '',
        endDate: '',
        time: []
      },
      tableData: [],
      ModelDecision: [],
      empty_img: require('../../assets/img/timg.jpg'),
      isLoading: true,
      activeName: 'first',
      showFa: 0,
      timeA: '',
      selectDate: '',
      choiceDate0: '',
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate && maxDate.getTime() > new Date().getTime()) {
            this.choiceDate = ''
          }
        },
        disabledDate: time => {
          const today = Date.now()
          if (this.choiceDate) {
            const range = 14 * 24 * 3600 * 1000
            let minTime = this.choiceDate - range
            let maxTime = this.choiceDate + range
            maxTime = maxTime > today ? today : maxTime
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return time.getTime() > today
        },
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }
          // {
          //   text: '最近一个月',
          //   onClick(picker) {
          //     const end = new Date()
          //     const start = new Date()
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          //     picker.$emit('pick', [start, end])
          //   }
          // }
          // {
          //   text: '最近三个月',
          //   onClick(picker) {
          //     const end = new Date()
          //     const start = new Date()
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          //     picker.$emit('pick', [start, end])
          //   }
          // }
        ]
      }
    }
  },
  created() {
    // 查询
    this.getGrowthModelDecisions()
    this.getUserDetails()
  },
  methods: {
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.showFa = 0
        this.searchForm.startDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0]
        this.searchForm.endDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]
        // this.searchForm.time = [this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0], this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]]
        // this.searchForm.startDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0]
        // this.searchForm.endDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]
        this.getParamData()
      } else {
        this.showFa = 1
        this.searchForm.time = [this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0], this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]]
        this.searchForm.startDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0]
        this.searchForm.endDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]
        this.getParamData()
      }
    },
    upMoment(val) {
      if (val == 0) {
        this.searchForm.startDate = moment(this.searchForm.controlDate).subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
      } else if (val == 1) {
        this.searchForm.startDate = moment(this.searchForm.controlDate).subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
      } else if (val == 2) {
        this.searchForm.startDate = moment(this.searchForm.controlDate).subtract(15, 'days').format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
      }
      this.getParamData()
    },
    upDay(val) {
      if (val == 0) {
        this.searchForm.controlDate = moment(this.searchForm.controlDate).subtract(1, 'days').format('YYYY-MM-DD')
        this.searchForm.startDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endDate = moment(this.searchForm.controlDate).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      } else if (val == 1) {
        this.searchForm.controlDate = moment(this.searchForm.controlDate).add(1, 'days').format('YYYY-MM-DD')
        // this.searchForm.startDate = moment(this.searchForm.controlDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        // this.searchForm.endDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.startDate = moment(this.searchForm.controlDate).format('YYYY-MM-DD HH:mm:ss')
        this.searchForm.endDate = moment(this.searchForm.controlDate).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
      }
      this.getList()
    },
    // 查询1
    handleSearch() {
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        decisionId: this.searchForm.decisionId,
        paramType: '',
        controlDate: this.$utils.zhDate(new Date().getTime()),
        controlTime: ['00:00:00', '23:59:59'],
        startDate: '',
        endDate: '',
        time: []
      }
      this.handleSearch()
    },
    getGrowthModelDecisions() {
      this.$api.photosynthesis.getGrowthModelDecisions().then(res => {
        if (res.code == 200) {
          res.data.map((item, index) => {
            if (Number(sessionStorage.getItem('USER_groupID'))) {
              console.log(456789)
              if (item.groupId == Number(sessionStorage.getItem('USER_groupID'))) {
                this.searchForm.decisionId = item.id
              }
            } else {
              this.searchForm.decisionId = res.data[0].id
            }
          })
          this.ModelDecision = res.data

          this.getList()
        }
      })
    },
    ChangeDecisionId(val) {
      this.searchForm.decisionId = val
      this.getList()
      this.saveUserGroup(val)
    },
    getUserDetails() {
      this.$api.system.getUserDetails(sessionStorage.getItem('USER_ID')).then(res => {
        if (res.code == 200) {
          sessionStorage.setItem('USER_groupID', res.data.groupId)
        }
      })
    },
    saveUserGroup(val) {
      let id = ''
      this.ModelDecision.map(item => {
        if (item.id == val) {
          id = item.groupId
        }
      })
      this.$api.system.saveUserGroup({ id: id }).then(res => {
        if (res.code == 200) {
        }
      })
    },
    // 获取数据
    getList() {
      if (this.searchForm.time.length == 0) {
        this.searchForm.time = [this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0], this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]]
      }
      // this.searchForm.decisionId = this.$route.query.decisionId
      if (this.searchForm.controlDate) {
        this.searchForm.startDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[0]
        this.searchForm.endDate = this.searchForm.controlDate + ' ' + this.searchForm.controlTime[1]
      }
      if (this.showFa == 1) {
        this.searchForm.startDate = this.searchForm.time[0]
        this.searchForm.endDate = this.searchForm.time[1]
      }
      this.tableData = []
      // 获取参数数据
      this.getParamData()
    },
    // 获取参数数据
    getParamData() {
      this.tableData = []
      this.isLoading = true
      this.$api.growthModel
        .getGrowthModelEvnParamChart({
          decisionId: this.searchForm.decisionId,
          // controlDate: this.searchForm.controlDate,
          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate
        })
        .then(res => {
          if (res.code == 200) {
            this.isLoading = false
            this.tableData = []

            if (res.data.length == 0) {
              return
            }
            res.data.map(item => {
              if (item.controlType == 0) {
                item.controlName = '整体控制'
              } else if (item.controlType == 1) {
                item.controlName = '局部控制'
              }
              if (item.paramType == 1) {
                item.paramName = '土壤水分'
              } else if (item.paramType == 2) {
                item.paramName = '土壤温度'
              } else if (item.paramType == 3) {
                item.paramName = '土壤PH'
              } else if (item.paramType == 4) {
                item.paramName = '土壤盐分'
              } else if (item.paramType == 5) {
                item.paramName = '土壤紧实度'
              } else if (item.paramType == 6) {
                item.paramName = '叶片温度'
              } else if (item.paramType == 7) {
                item.paramName = '叶片湿度'
              } else if (item.paramType == 8) {
                item.paramName = '冠层温度'
              } else if (item.paramType == 9) {
                item.paramName = '光照时长'
              } else if (item.paramType == 10) {
                item.paramName = '空气温度'
              } else if (item.paramType == 11) {
                item.paramName = '空气湿度'
              } else if (item.paramType == 12) {
                item.paramName = 'CO2'
              } else if (item.paramType == 13) {
                item.paramName = '光照强度'
              } else if (item.paramType == 14) {
                item.paramName = '光合有效辐射'
              } else if (item.paramType == 15) {
                item.paramName = '大气压强'
              } else if (item.paramType == 16) {
                item.paramName = '水氮'
              } else if (item.paramType == 17) {
                item.paramName = '水磷'
              } else if (item.paramType == 18) {
                item.paramName = '水钾'
              } else if (item.paramType == 19) {
                item.paramName = '水温'
              } else if (item.paramType == 20) {
                item.paramName = '水氧'
              }
              this.tableData.push(item)
              this.dealData(item)
            })
            // res.data.forEach((val) => {
            //   if (val.hisDataList && val.hisDataList.length > 0) {
            //     val.hisDataList.forEach((val2) => {

            //       // 处理数据
            //     })

            //     // this.tableData.sort()
            //   }
            // })
            // var last = this.tableData.pop()
            // this.tableData.unshift(last)
            // console.log(last)
          }
        })
    },
    // 处理数据
    dealData(val) {
      let id = val.id + `${this.showFa}`

      let xDataList = []
      let yDataList = []

      if (this.showFa == 1) {
        var timeA = ''
        val.dataMap.xTimes.forEach((t, i) => {
          let time = moment(t).format('MM-DD')
          if (timeA != time) {
            timeA = time
            xDataList.push(moment(t).format('MM-DD  HH:mm'))
          } else {
            xDataList.push(moment(t).format('HH:mm'))
          }
        })
      } else {
        val.dataMap.xTimes.forEach(t => {
          xDataList.push(moment(t).format('HH:mm'))
        })
      }
      let y = []
      let yup = []
      let lower = []
      val.dataMap.yDatas.forEach(d => {
        y.push(d.value)
        yup.push(val.upValue)
        lower.push(val.lowerValue)
      })

      // 加载历史数据折线
      yDataList.push({
        name: '实际数据',
        type: 'line',
        symbol: 'none',
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          color: '#0356fe'
        },
        data: y
      })
      yDataList.push({
        name: '期望上限',
        type: 'line',
        symbol: 'none',
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          color: '#1aa034',

          type: 'dotted' //'dotted'虚线 'solid'实线
        },
        data: yup
      })
      yDataList.push({
        name: '期望下限',
        type: 'line',
        symbol: 'none',
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          color: '#373737',
          type: 'dotted' //'dotted'虚线 'solid'实线
        },
        data: lower
      })
      // 控制时间段数据折线
      // val.dataMap.controlDatas.forEach((d) => {
      //   let color = ''
      //   if (d.status == 0) {
      //     // 待确认
      //     color = '#373737'
      //   } else if (d.status == 1) {
      //     // 调控成功
      //     color = 'rgba(87, 248, 13, 1)'
      //   } else if (d.status == 2) {
      //     // 调控失败
      //     color = 'rgba(236, 5, 5, 1)'
      //   }

      // })
      // 初始化
      this.$nextTick(() => {
        this.initChart(xDataList, yDataList, id)
      })
    },
    // 初始化图表
    initChart(xDataList, yDataList, id) {
      var myChart = document.getElementById(id)
      // myChart.removeAttribute('echarts_instance')
      var chartObj = echarts.init(myChart)

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function (params) {
            var html = ''
            if (params.length != 0) {
              var getName = params[0].name
              html += getName + '<br/>'
              for (let i = 0; i < params.length; i++) {
                // 如果为0 为空的数据我们不要了
                if (params[i].value != null && params[i].value != 0 && params[i].value != '') {
                  // params[i].marker 需要加上，否则你鼠标悬浮时没有样式了
                  html += params[i].marker
                  html += params[i].seriesName + ':' + params[i].value + '<br/>'
                }
              }
            }
            return html
          }
        },
        color: ['#0356fe', '#1aa034', '#373737'],
        legend: {
          textStyle: {
            //图例文字的样式
            color: '#6a7985',
            fontSize: 14
          }
        },
        xAxis: {
          axisLabel: {
            showMaxLabel: false,
            rotate: 45,
            interval: (index, value) => {
              console.log(value.slice(3, 5), 999)

              if (this.showFa == 1) {
                if ((value.slice(0, 2) % 6 == 0 && value.slice(3, 5) == '00') || value.slice(7, 12) == '00:00') {
                  return true
                } else {
                  return false
                }
              } else if (value.slice(0, 2) % 2 == 0 && value.slice(3, 5) == '01') {
                return true
              }
            }
            //  function (index, value) {
            //value.slice(0, 2) % 6 == 0 &&

            //   // 自定义换行逻辑，这里以每两个字符换行为例
            //   return value.split('  ').join('\n')
            // }
          },
          type: 'category',
          data: xDataList,
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
        },
        series: yDataList,
        // dataZoom: [
        //   {
        //     height: 20, //时间滚动条的高度
        //     type: 'slider', //type的作用是指定数据缩放的类型，slider表示使用滑动条进行缩放，inside表示使用鼠标滚轮进行缩放。
        //     xAxisIndex: 0, //作用在x轴的下标（因为x轴可以有多个）
        //     filterMode: 'filter', //间滚动条的过滤模式,'filter'表示滑动时间条时会直接过滤掉不在时间范围内的数据，'weakFilter'表示滑动时间条时会逐渐过滤掉不在时间范围内的数据。
        //     start: 0, //默认开始位置（百分比）
        //     end: 100 //默认结束位置（百分比）
        //   },
        //   {
        //     type: 'inside',
        //     xAxisIndex: 0,
        //     filterMode: 'filter',
        //     start: 0,
        //     end: 100
        //   }
        // ],

        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: '8%',
          right: '5%',
          bottom: '25%'
        }
      }
      chartObj.setOption(option)
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1600px) {
  .el-col-lg-8 {
    width: 33.33333% !important;
  }
}
@import '@/style/decisionManagement.scss';
li {
  padding-left: 10px;
}
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}
h5 {
  font-size: 14px !important;
}
.title_1 {
  font-size: 11px;
}
.fs {
  font-weight: bold;
  font-size: 12px;
}
</style>
